import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})

export class ControllersService {

	constructor(private http: HttpClient) { }

	private authHeader(): string {
		return `Bearer ${JSON.parse(localStorage.getItem('User')).token}`;
	}

	public get() {
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', this.authHeader());

		return this.http.get(`${environment.apiUrl}/sistema/Controllers`, { headers });
	}

	public post(body) {
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', this.authHeader());

		return this.http.post(`${environment.apiUrl}/sistema/Controllers`, body, { headers });
	}

	public delete(codGrupoAcesso, codActionController) {
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', this.authHeader());

		return this.http.delete(`${environment.apiUrl}/sistema/Controllers/${codGrupoAcesso}/${codActionController}`, { headers });
	}
}